// '@aws-amplify/auth/dist/esm/providers/cognito/types/errors'

enum CognitoSignUpException {
   CodeDeliveryFailureException = "CodeDeliveryFailureException",
   InternalErrorException = "InternalErrorException",
   InvalidEmailRoleAccessPolicyException = "InvalidEmailRoleAccessPolicyException",
   InvalidLambdaResponseException = "InvalidLambdaResponseException",
   InvalidParameterException = "InvalidParameterException",
   InvalidPasswordException = "InvalidPasswordException",
   InvalidSmsRoleAccessPolicyException = "InvalidSmsRoleAccessPolicyException",
   InvalidSmsRoleTrustRelationshipException = "InvalidSmsRoleTrustRelationshipException",
   NotAuthorizedException = "NotAuthorizedException",
   ResourceNotFoundException = "ResourceNotFoundException",
   TooManyRequestsException = "TooManyRequestsException",
   UnexpectedLambdaException = "UnexpectedLambdaException",
   UserLambdaValidationException = "UserLambdaValidationException",
   UsernameExistsException = "UsernameExistsException",
   LimitExceededException = "LimitExceededException",
   AutoSignInException = "AutoSignInException"
}

export default CognitoSignUpException